import { DatePicker } from '@material-ui/pickers'
import { Moment } from 'moment'
import React from 'react'
import { Field } from 'react-final-form'

interface Props {
    name: string
    helperText?: React.ReactNode
    label?: string | React.ReactNode
    shouldDisableDate?: (day: Moment) => boolean
    margin?: 'dense' | 'normal' | 'none'
    minDate?: Moment
    required?: boolean
}

const DateField: React.FC<Props> = ({ name, helperText, label, minDate, margin = 'normal', required }) => {
    return (
        <Field name={name}>
            {({ input: { onChange, value }, meta }) => {
                const showError =
                    ((meta.submitError && !meta.dirtySinceLastSubmit) || meta.error) && meta.touched
                return (
                    <DatePicker
                        helperText={helperText}
                        required={required}
                        margin={margin}
                        minDate={minDate}
                        label={label}
                        value={value}
                        onChange={onChange}
                        error={showError}
                        fullWidth
                    />
                )
            }}
        </Field>
    )
}

export default DateField
